module.exports = __webpack_public_path__ + "img/slide_1.016e77c3.jpg";